import NamedCheckbox from '../NamedCheckbox'
import StateOffcanvas from '../Offcanvas'
import { useSettings } from 'Settings'

export function BluePanel({ handle, onHide }) {
	const [settings] = useSettings()
	const supervisory = settings['supervisory']

	return (
		<StateOffcanvas handle={handle} onHide={onHide} trigger="blue" title="STS/LTS/HRV Supervisory Settings">
			<NamedCheckbox
				name="Battery Protector"
				value={supervisory['battery protector'].value}
				onChange={(e) => {
					supervisory['battery protector'].setValue(e.target.checked)
				}}
			/>
			<NamedCheckbox
				name="Always Connect"
				value={supervisory['always connect'].value}
				onChange={(e) => {
					supervisory['always connect'].setValue(e.target.checked)
				}}
			/>
		</StateOffcanvas>
	)
}
